import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from '../../pages/content-pages/logout/logout.component';
import { RefreshPasswordComponent } from '../../pages/content-pages/refresh-password/refresh-password.component';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'basic',
    loadChildren: () => import('../../basic/basic.module').then(m=>m.BasicModule)
  },
  {
    path: 'salesorder',
    loadChildren: () => import('../../salesorder/salesorder.module').then(m=>m.SalesOrderModule)
  },
  {
    path: 'budget',
    loadChildren: () => import('../../budget/budget.module').then(m => m.BudgetModule)
  },
  {
    path: 'inquiry',
    loadChildren: () => import('../../inquiry/inquiry.module').then(m => m.InquiryModule)
  },
  {
    path: 'inquiryversionwisedetails',
    loadChildren: () => import('../../inquiryversionwisedetails/inquiryversionwisedetails.module').then(m => m.InquiryVersionWiseModule)
  },
  {
    path: 'financeReport',
    loadChildren: () => import('../../financeReport/financeReport.module').then(m => m.FinanceReportModule)
  },
  {
    path: 'DepoWiseSalesReport',
    loadChildren: () => import('../../DepoWiseSales/DepoWiseSales.module').then(m => m.DepoWiseSalesModule)
  },
 {
    path: 'balanceConfirmationreport',
    loadChildren: () => import('../../balanceConfirmationReport/balanceConfirmationReport.module').then(m => m.BalanceConfirmationReportModule)
  },
  
  {
    path: 'balanceConfirmationReport_Desc',
    loadChildren: () => import('../../balanceConfirmationReport_Desc/balanceConfirmationReport_Desc.module').then(m => m.balanceConfirmationReport_DescModule)
  },
  {
    path: 'Stock',
    loadChildren: () => import('../../Stock/Stock.module').then(m => m.StockVsCustomerReportModule)
  },
  {
    path: 'GSTRTransferReport',
    loadChildren: () => import('../../GSTRTransferReport/GSTRTransferReport.module').then(m => m.GSTRTTransferReportModule)
  },
  {
    path: 'masters',
    loadChildren: () => import('../../masters/master.module').then(m => m.MasterModule)
  },
  {
    path: 'ComplaintRegister',
    loadChildren: () => import('../../ComplaintRegister/ComplaintRegister.module').then(m => m.ComplaintRegisterModule)
  },
  {
    path: 'WMScoilscanReport',
    loadChildren: () => import('../../WMScoilscanReport/WMScoilscanReport.module').then(m => m.WMScoilscanReportModule)
  },
  {
    path: 'Downloads',
    loadChildren: () => import('../../InvoiceDetailDownload/InvoiceDetailDownload.module').then(m => m.InvoiceDetailDownloadModule)
  },
  {
    path: 'settlement',
    loadChildren: () => import('../../settlement/settlementProcess.module').then(m => m.settlementProcessModule)
  },
  {
    path: 'SegmentDataUpload',
    loadChildren: () => import('../../SegmentDataUpload/SegmentDataUpload.module').then(m => m.SegmentDataUploadModule)
  },
{
    path: 'stockVisibility',
    loadChildren: () => import('../../stockVisibility/stockVisibility.module').then(m => m.stockVisibilityModule)
  },
  {
    path: 'TransporterLeadTimeReport',
    loadChildren: () => import('../../TransporterLeadTimeReport/transporterLeadTimeReport.module').then(m => m.TransporterLeadTimeModule)
  }, {
    path: 'warranty',
    loadChildren: () => import('../../WarrantyRegistration/WarrantyRegistration.module').then(m => m.WarrantyRegistrationModule)
  }, {
    path: 'WarrantyRegistration',
    loadChildren: () => import('../../WarrantyRegistration/WarrantyRegistration.module').then(m => m.WarrantyRegistrationModule)
  }
  , {
    path: 'WarrantyStatus',
    loadChildren: () => import('../../WarrantyStatus/WarrantyStatus.module').then(m => m.WarrantyStatusModule)
  }, {
    path: 'WarrantyCustomerDetails',
    loadChildren: () => import('../../WarrantyCustomerDetails/WarrantyCustomerDetails.module').then(m => m.WarrantyCustomerDetailsModule)
  },
  {
    path: 'WarrantyStatusView',
    loadChildren: () => import('../../WarrantyStatusView/WarrantyStatusView.module').then(m => m.WarrantyStatusViewModule)
  },
  {
    path: 'WarrantyExtentionMaster',
    loadChildren: () => import('../../WarrantyExtentionMaster/WarrantyExtentionMaster.module').then(m => m.WarrantyExtentionMasterModule)
  },
  {
    path: 'WarrantyExchanges',
    loadChildren: () => import('../../WarrantyExchanges/WarrantyExchanges.module').then(m => m.WarrantyExchangesModule)
  },
  {
    path: 'TechnicalInformation',
    loadChildren: () => import('../../TechnicalInformation/technicalInformation.module').then(m => m.TechnicalInformationModule)
  },
  {
    path: 'WarrantyExchangeMaster',
    loadChildren: () => import('../../WarrantyExchangeMaster/WarrantyExchangeMaster.module').then(m => m.WarrantyExchangeMasterModule)
  },
  {
    path: 'Report',
    loadChildren: () => import('../../CustomerWarrantyExchangeReport/CustomerWarrantyExchangeReport.module').then(m => m.CustomerWarrantyExchangeReportModule)
  },

  {
    path: 'PSOWiseReport',
    loadChildren: () => import('../../PSOWiseReport/psowisereport.module').then(m => m.PSOWiseReport)
  },
  {

    path: 'SalesMonthlyItemWiseReport',
    loadChildren: () => import('../../SalesMonthlyItemWiseReport/salesMonthlyItemWiseReport.module').then(m => m.salesMonthlyItemWiseReport)
  },
  {
    path: 'KabelConnectInvoiceReport',
    loadChildren: () => import('../../KabelConnectInvoiceReport/KabelConnectInvoiceReport.module').then(m => m.KabelConnectInvoiceReportModule)
  },
  {

    path: 'SITProcess',
    loadChildren: () => import('../../SITProcess/SITProcess.module').then(m => m.SITProcessReport)
  }, 
   {
 
     path: 'SITFileUpload',
     loadChildren: () => import('../../SITFileUpload/SITFileUpload.module').then(m => m.SITFileUploadModule)
  },
  {

    path: 'CustomerDeclaration',
    loadChildren: () => import('../../CustomerDeclaration/CustomerDeclaration.module').then(m => m.CustomerDeclarationModule)
  },
  {
    path: 'QuoteParameter',
    loadChildren: () => import('../../inquiry/inquiry.module').then(m => m.InquiryModule)
  }, {
    path: 'SettlementReport',
    loadChildren: () => import('../../SettlementReport/SettlementReport.module').then(m => m.SettlementReportReportModule)
  },
  {
    path: 'WMSLocationReport',
    loadChildren: () => import('../../WMSLocationReport/WMSLocationReport.module').then(m => m.WMSLocationReportModule)
  },
  {

    path: 'BarcodeDetailReport',
    loadChildren: () => import('../../ProductionReport/ProductionReport.module').then(m => m.ProductionReportModule)
  },
  {
    path: 'PB_UploadTables',
    loadChildren: () => import('../../PB_AllIndiaHygiene/PB_AllIndiaHygiene.module').then(m => m.PB_AllIndiaHygieneModule)
  },
  {
    path: 'CP_Reports',
    loadChildren: () => import('../../CP_Reports/CP_Reports.module').then(m => m.CP_ReportsModule)
  },
  {

    path: 'SalesReturnPortal',
    loadChildren: () => import('../../SalesReturnPortal/SalesReturnPortal.module').then(m => m.SalesReturnPortalModule)
  },
  {
    path: 'customercollectionupload',
    loadChildren: () => import('../../customercollectionupload/customercollectionupload.module').then(m => m.customercollectionuploadModule)
  },
  {
    path: 'FMEGStockReport',
    loadChildren: () => import('../../FMEGStockReport/FMEGStockReport.module').then(m => m.FMEGStockReportModule)
  },
  {
    path: 'AssetManagement',
    loadChildren: () => import('../../AM_AssetManagement/AM_AssetManagement.module').then(m => m.AM_AssetManagementModule)
  },
  {
    path: 'SupplierBalanceConfirmationReport',
    loadChildren: () => import('../../SupplierBalanceConfirmationReport/SupplierBalanceConfirmationReport.module').then(m => m.SupplierBalanceConfirmationReportModule)
  },
  {
    path: 'VendorOutstandingReport',
    loadChildren: () => import('../../VendorOutstandingReport/VendorOutstandingReport.module').then(m => m.VendorOutstandingModule)
  },
  {
    path: 'pendingPO',
    loadChildren: () => import('../../pendingPO/pendingPO.module').then(m => m.PendingPOModule)
  }
  ,
  {
    path: 'FMEGHistory',
    loadChildren: () => import('../../FMEGHistory/FMEGHistory.module').then(m => m.FMEGHistoryModule)
  },
  {
    path: 'RR_MonthlyInventory',
    loadChildren: () => import('../../RR_MonthlyInventory/RR_MonthlyInventory.module').then(m => m.RR_MonthlyInventoryModule)
  },
  {
    path: 'SwitchStockReport',
    loadChildren: () => import('../../SwitchStockReport/SwitchStockReport.module').then(m => m.SwitchStockReportModule)
  },
  {
    path: 'ExportDocumentDetail',
    loadChildren: () => import('../../ExportDocumentDetail/ExportDocumentDetail.module').then(m => m.ExportDocumentDetailModule)
  },
  {
    path: 'TrackerInquiry',
    loadChildren: () => import('../../inquiry-traker/inquiry-traker.module').then(m => m.InquiryTrackerModule)
  },
  {
    path: 'CNDNReport',
    loadChildren: () => import('../../cn-dn-download/cn-dn-download.module').then(m => m.CNDNDownloadModule)
  },
  //{
  //  path: 'CRM_salesorder',
  //  loadChildren: () => import('../../CRM-ESaleOrderEntry/CRM-ESaleOrderEntry.module').then(m => m.CRM_SalesOrderModule)
  //},
  //{
  //  path: 'logout',
  //  component: LogoutComponent,
  //  data: {
  //    title: 'Logout'
  //  }
  //},
  //{
  //  path: 'CustomerFeedbackReport',
  //  loadChildren: () => import('../../customer-feedback-report/customer-feedback-report.module').then(m => m.CustomerFeedbackReportModule)
  //},
  //{
  //  path: 'UserTrackingLog',
  //  loadChildren: () => import('../../user-tracking-log/user-tracking-log.module').then(m => m.UserTrackingLogModule)
  //},
  {
    path: 'ZoneWiseBudgetReport',
    loadChildren: () => import('../../ZoneWiseBudgetReport/ZoneWiseBudgetReport.module').then(m => m.ZoneWiseBudgetReportModule)
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout'
    }
  },
  {
    path: 'reset-password',
    component: RefreshPasswordComponent,
    data: {
      title: 'reset-password'
    }
  },
  {
    path: 'DealerUserMapping',
    loadChildren: () => import('../../dealer-user-mapping/dealer-user-mapping.module').then(m => m.DealerUserMappingModule)
  },
  {
    path: 'itemSearch_AI',
    loadChildren: () => import('../../itemSearch_AI/itemSearch_AI.module').then(m => m.itemSearch_AIModule)
  },
  {
    path: 'CF_CustBankMapping',
    loadChildren: () => import('../../CF_CustBankMapping/CF_CustBankMapping.module').then(m => m.CF_CustBankMappingModule)
  },
  {
    path: 'CF_OutstandingReport',
    loadChildren: () => import('../../CF_OutstandingReport/CF_OutstandingReport.module').then(m => m.CF_OutstandingReportModule)
  },
  {
    path: 'CF_DownloadReport',
    loadChildren: () => import('../../CF_DownloadReport/CF_DownloadReport.module').then(m => m.CF_DownloadReportModule)
  },
  {
    path: 'CRM_salesorder',
    loadChildren: () => import('../../CRM-ESaleOrderEntry/CRM-ESaleOrderEntry.module').then(m => m.CRM_SalesOrderModule)
  },
  {
    path: 'CRMQuotationForDealer',
    loadChildren: () => import('../../CRM-QuotationForDealer/CRM-QuotationForDealer.module').then(m => m.CRMQuotationForDealerModule)
  },
 {
   path: 'CRMOrderForDealer',
   loadChildren: () => import('../../CRM-OrderForDealer/CRM-OrderForDealer.module').then(m => m.CRMQuotationForDealerModule)
 },
 {
   path: 'CRMPlantOrderForDealer',
   loadChildren: () => import('../../CRM-PlantOrderForDealer/CRM-PlantOrderForDealer.module').then(m => m.CRMPlantForDealerModule)
  },
  {
    path: 'ProvisionReport',
    loadChildren: () => import('../../ProvisionReport/ProvisionReport.module').then(m => m.ProvisionReportModule)
  }
  //{
  //  path: 'charts',
  //  loadChildren: () => import('../../charts/charts.module').then(m => m.ChartsNg2Module)
  //},
  // {
  //  path: 'forms',
  //  loadChildren: () => import('../../forms/forms.module').then(m => m.FormModule)
  //},
  //{
  //  path: 'maps',
  //  loadChildren: () => import('../../maps/maps.module').then(m => m.MapsModule)
  //},
  //{
  //  path: 'tables',
  //  loadChildren: () => import('../../tables/tables.module').then(m => m.TablesModule)
  //},
  //{
  //  path: 'datatables',
  //  loadChildren: () => import('../../data-tables/data-tables.module').then(m => m.DataTablesModule)
  //},
  //{
  //  path: 'uikit',
  //  loadChildren: () => import('../../ui-kit/ui-kit.module').then(m => m.UIKitModule)
  //},
  //{
  //  path: 'components',
  //  loadChildren: () => import('../../components/ui-components.module').then(m => m.UIComponentsModule)
  //},
  //{
  //  path: 'pages',
  //  loadChildren: () => import('../../pages/full-pages/full-pages.module').then(m => m.FullPagesModule)
  //},
  //{
  //  path: 'cards',
  //  loadChildren: () => import('../../cards/cards.module').then(m => m.CardsModule)
  //},
  //{
  //  path: 'chat',
  //  loadChildren: () => import('../../chat/chat.module').then(m => m.ChatModule)
  //},
  //{
  //  path: 'chat-ngrx',
  //  loadChildren: () => import('../../chat-ngrx/chat-ngrx.module').then(m => m.ChatNGRXModule)
  //},
  //{
  //  path: 'inbox',
  //  loadChildren: () => import('../../inbox/inbox.module').then(m => m.InboxModule)
  //},
  //{
  //  path: 'taskboard',
  //  loadChildren: () => import('../../taskboard/taskboard.module').then(m => m.TaskboardModule)
  //},
  //{
  //  path: 'taskboard-ngrx',
  //  loadChildren: () => import('../../taskboard-ngrx/taskboard-ngrx.module').then(m => m.TaskboardNGRXModule)
  //}

];
